/* unplugin-vue-components disabled */import { render } from "./chats-item.vue?vue&type=template&id=793ed704&scoped=true"
import script from "./chats-item.vue?vue&type=script&lang=js"
export * from "./chats-item.vue?vue&type=script&lang=js"

import "./chats-item.vue?vue&type=style&index=0&id=793ed704&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793ed704"],['__file',"src/components/navbar/chats-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "793ed704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('793ed704', __exports__)) {
    api.reload('793ed704', __exports__)
  }
  
  module.hot.accept("./chats-item.vue?vue&type=template&id=793ed704&scoped=true", () => {
    api.rerender('793ed704', render)
  })

}


export default __exports__